import getBoundingBox from './getBoundingBox'

export { getBoundingBox }
